import UploadFieldValueForSave from '@/VueComponents/Uploads/models/uploadFieldValueForSave';

export default class UploadMetadataForSave {
  constructor(
    public uploadId: string,
    public uploadFieldValues: UploadFieldValueForSave[]
  ) { }
}